import { inject, Injectable, signal } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { AcquisitionType, StaticDataRestService } from '../../_generated';
@Injectable({
    providedIn: 'root',
})
export class StaticDataService {
    private readonly staticDataRestService = inject(StaticDataRestService);

    private acquisitionTypesSignal = signal<AcquisitionType[]>([]);

    acquisitionTypes = this.acquisitionTypesSignal.asReadonly();

    getAcquisitionTypes(): Observable<AcquisitionType[]> {
        return this.staticDataRestService.staticDataControllerGetAcquisitionType().pipe(
            tap((acquisitionTypes) => {
                return this.acquisitionTypesSignal.set(acquisitionTypes);
            }),
        );
    }

    getMax3aValues(date: Date = new Date()): Observable<{
        max3aAngestellt: number;
        max3aSelbststaendig: number;
    }> {
        return this.staticDataRestService.staticDataControllerGetMax3aValues(date.toISOString()).pipe(
            map((staticData) => {
                return {
                    max3aAngestellt: Number(staticData.find((data) => data.type === 'max3aAngestellt')?.value) || 0,
                    max3aSelbststaendig: Number(staticData.find((data) => data.type === 'max3aSelbststaendig')?.value) || 0,
                };
            }),
        );
    }
}
